/** @format */

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_STAGING_URL,
});

axiosInstance.interceptors.request.use(interceptor, networkError);

function interceptor(config) {
  if (config.skipAppParams) {
    return config;
  }

  const userDetails = JSON.parse(localStorage.getItem('USER_DETAILS'));
  const params = JSON.parse(localStorage.getItem('params'));

  const excludeParams = ['PAGES', 'COLUMN_LIST', 'DROPDOWN_LIST'];

  const extracted =
    params?.filter((item) => !excludeParams.includes(item.Param_Name)) || [];

  if (userDetails) {
    config.data = config.data || {};

    config.data.Client_Id = userDetails.client_id;
    config.data.Domain_Id = userDetails.domain_id;
    config.data.branch_id = userDetails.branch_id;

    extracted.forEach((item) => {
      config.data[item.Param_Name] = item.Param_Value_Jsonb;
    });
  }

  return config;
}

function networkError(error) {
  return Promise.reject(error);
}

export default axiosInstance;
